import {useLocation} from "react-router-dom";

export const useTab = () => {
  const {search} = useLocation();
  const queryParams = new URLSearchParams(search);
  return queryParams.get("tab") || "digest";
};
